<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="address"
          label="Địa chỉ"
          class="required"
          placeholder="Nhập địa chỉ"
          :rules="[$rules.required]"
          hide-details="auto"
          outlined
          dense
        />
      </v-col>
      <v-col cols="6" class="d-flex align-center">Giờ đến điểm (24h)</v-col>
      <v-col cols="6">
        <TimeInput
          ref="timeInput"
          label="Giờ đến (24h)"
          outlined
          dense
          outline
          :date.sync="timeIn"
          :selectedDate="getCurrentDate"
          :rules="[$rules.time]"
        />
      </v-col>
      <v-col cols="6" class="d-flex align-center">Giờ rời điểm (24h)</v-col>
      <v-col cols="6">
        <TimeInput
          label="Giờ rời (24h)"
          outlined
          dense
          outline
          :date.sync="timeOut"
          :selectedDate="getCurrentDate"
          :rules="[$rules.time]"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="coordinate"
          label="Toạ độ (Vĩ độ, Kinh độ)"
          placeholder="21.01597204464522,105.7804508138395"
          hide-details
          outlined
          dense
        />
      </v-col>
      <v-divider />
      <div class="ml-2" v-if="isUpdateForm">
        <v-checkbox hide-details v-model="applySameAddress" label="Áp dụng cho toàn bộ điểm dừng có cùng địa chỉ" />
        <v-checkbox
          hide-details
          v-if="applySameAddress"
          v-model="applySameSchedule"
          class="ml-2"
          label="Áp dụng cho toàn bộ điểm dừng có cùng địa chỉ và chiều di chuyển"
        />
      </div>

      <v-col cols="12" v-if="!busStopData || !busStopData.id">
        <v-checkbox v-model="week" label="Tạo mới tất cả các ngày trong tuần" class="py-0 my-0" hide-details="auto">
        </v-checkbox>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import TimeInput from '@/components/basic/TimeInput.vue'
import moment from 'moment'
import { textHelpers } from '@/helpers/TextHelper.js'
import { get } from 'lodash'

export default {
  components: {
    TimeInput,
  },
  props: {
    busStopData: {
      type: Object,
      default: () => {},
    },
    isUpdateForm: Boolean,
  },
  computed: {
    ...mapState('constant', ['busStatus']),
    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    },
  },
  data: () => ({
    address: '',
    timeIn: '',
    timeOut: '',
    week: false,
    coordinate: null,
    applySameAddress: false,
    applySameSchedule: false,
  }),
  methods: {
    validate() {
      if (this.timeOut && this.timeIn && moment(this.timeOut).isBefore(moment(this.timeIn))) {
        this.$alert.error('Giờ về phải lớn hơn giờ đến')
        return
      }

      return this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
      this.setIsRule(false)
    },
    setIsRule(status) {
      this.$refs.timeInput.setIsRule(status)
    },
    resetDefault() {
      if (this.busStopData) {
        this.address = this.busStopData.address
        this.timeIn = this.handleBusStopTime('timeIn')
        this.timeOut = this.handleBusStopTime('timeOut')
        if (this.busStopData.lat && this.busStopData.long)
          this.coordinate = [this.busStopData.lat, this.busStopData.long].join(',')
        else this.coordinate = null
      } else {
        this.address = null
        this.timeIn = null
        this.timeOut = null
        this.coordinate = null
      }
      this.applySameAddress = false
      this.applySameSchedule = false
    },
    handleBusStopTime(propName = '') {
      const originTime = get(this.busStopData, propName, '')
      if (originTime.includes(':')) {
        const [h, m] = originTime.split(':')
        return moment().hour(h).minute(m).toISOString()
      }
      return null
    },
    getData() {
      const res = {
        address: textHelpers.removeSpaces(this.address),
        timeIn: moment(this.timeIn).format('HH:mm'),
        timeOut: this.timeOut ? moment(this.timeOut).format('HH:mm') : '',
        week: this.week,
      }
      if (typeof this.coordinate === 'string' && this.coordinate.length) {
        const [lat, long] = this.coordinate.split(',')
        res['lat'] = Number(lat)
        res['long'] = Number(long)
      }
      if (this.isUpdateForm) {
        if (this.applySameAddress) {
          res['sops'] = {
            applySameAddress: true,
          }
          if (this.applySameSchedule) res['sops']['applySameSchedule'] = true
        }
      }

      return res
    },
  },
  created() {
    this.resetDefault()
  },
  watch: {
    busStopData() {
      this.resetDefault()
    },
  },
}
</script>
